// extracted by mini-css-extract-plugin
export default {"root":"Skeleton_root_YnHkf","pulsate":"Skeleton_pulsate_euOQc","text":"Skeleton_text_bw4_R","circle":"Skeleton_circle_UQHYh","rectangle":"Skeleton_rectangle_QN2zf"};